<template>
	<svg width="102" height="102" viewBox="0 0 102 102" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M57.7719 98.4349C58.8765 98.4349 59.7719 97.5394 59.7719 96.4349L59.7719 93.7935L43.4201 93.7935L43.4201 96.4349C43.4201 97.5394 44.3155 98.4349 45.4201 98.4349L57.7719 98.4349ZM59.7719 78.8043L59.7719 83.8007L43.4201 83.8007L43.4201 78.8043L59.7719 78.8043ZM43.4201 73.8079L59.7719 73.8079L59.7719 39.1399L79.2403 56.8262C79.6232 57.1741 80.2082 57.1725 80.5892 56.8225L91.6726 46.6417C92.1047 46.2448 92.1038 45.5627 91.6706 45.167L51.5343 8.5L11.5187 45.2817C11.0876 45.678 11.0877 46.3582 11.519 46.7544L22.6018 56.9347C22.9841 57.2858 23.5714 57.2861 23.954 56.9354L43.4201 39.0934L43.4201 73.8079Z" :fill="fill_color"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
